<template>
  <div class="ds-textarea">
    <textarea
      class="ds-textarea__input"
      ref="textarea"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :aria-invalid="isMarkedAsInvalid || (hasErrors && !modelValue)"
      :rows="rows"
      :maxlength="maxlength"
      :data-test-id="dataTestId"
      :data-min-rows="dataMinRows"
      :data-max-rows="dataMaxRows"
      @input="onInput($event.target.value)"
      @change="$emit('change', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <FormCaption
      v-if="caption"
      type="info"
      class="mt-1"
    >
      {{ caption }}
    </FormCaption>
    <div class="flex justify-between">
      <FormCaption
        v-if="hasErrors&&!hideErrorsCaption"
        type="invalid"
        class="mt-1"
      >
        {{ firstError }}
      </FormCaption>
      <div v-if="maxCharactersCounter"
        class="text-xs grow text-right whitespace-nowrap"
      >
        {{ internalModel.length }} / {{ maxCharactersCounter }}
      </div>
    </div>
  </div>
</template>

<script>
import htmlProps from '../htmlProps.js';
import FormCaption from './FormCaption.vue';
import validation from './validation-mixin';

export default {
  name: 'TextareaField',
  emits: ['change', 'update:modelValue', 'blur', 'focus'],
  mixins: [validation, htmlProps],
  components: { FormCaption },
  props: {
    modelValue: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    rows: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: String,
      required: false,
    },
    autogrow: {
      type: Boolean,
      default: false,
    },
    dataMinRows: {
      type: Number,
      default: null,
    },
    dataMaxRows: {
      type: Number,
      default: null,
    },
    maxCharactersCounter: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      internalModel: this.modelValue,
    };
  },
  methods: {
    onInput(value) {
      this.$emit('update:modelValue', value);
      this.internalModel = value;
    },
  },
  mounted() {
    if (!this.autogrow) {
      return;
    }
    this.$nextTick(() => {
      $(this.$refs.textarea).autoexpand();
    });
  },
};
</script>
